module.exports = __webpack_public_path__ + "img/icon.617a7fb3.png";